import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-flex-content',
    templateUrl: './block-flex-content.component.html',
})

export class BlockFlexContentComponent extends BlockAbstractComponent implements OnInit {

}
